module.exports = __webpack_public_path__ + "img/bkash.d5350c21.png";